module.exports = __webpack_public_path__ + "static/media/status.dff6f9d1.svg";